import { render, staticRenderFns } from "./wf-yes-no-factor-display.vue?vue&type=template&id=2c624336&scoped=true&"
import script from "./wf-yes-no-factor-display.vue?vue&type=script&lang=ts&"
export * from "./wf-yes-no-factor-display.vue?vue&type=script&lang=ts&"
import style0 from "./wf-yes-no-factor-display.vue?vue&type=style&index=0&id=2c624336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c624336",
  null
  
)

export default component.exports